let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("65ciN")).then(() => parcelRequire('eML1P'));